import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NewNicaFormComponent } from '../../nica-form/new-nica-form.component';
import { NicaAnagraficaComponent } from '../../nica-anagrafica/nica-anagrafica.component';

@Component({
  selector: 'app-crm-aggiornamenti',
  templateUrl: './crmAggiornamenti.component.html',
  styleUrls: ['./crmAggiornamenti.component.css']
})
export class CrmAggiornamentiComponent implements OnInit {
  @ViewChild('crmFiltriAggForm', { static: true }) crmFiltriAggForm: NewNicaFormComponent
  @ViewChild('crmFiltriAggGrid', { static: true }) crmFiltriAggGrid: NicaAnagraficaComponent
  myFilter = ''
  CustomButtonSetForm = [
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Applica',
      icon: "dx-icon-unpin",
      event: 'applica',
    },

    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Cancella',
      icon: "dx-icon-revert",
      event: 'cancella',
    },
  ];
  constructor() { }

  ngOnInit() {
  }
  emittendButtonPush(e) {
    console.log(e)
    console.log(this.crmFiltriAggForm.dataSet)
    if (e.name === 'applica') {
      this.crmFiltriAggForm.generaOdata().then((resp: string) => {
        let oData = resp
        if (oData.includes('RagSoc1_Agente')) oData = oData.replace('RagSoc1_Agente', 'agente')
        if (oData.includes('daData')) oData = oData.replace('daData', 'dataora')
        if (oData.includes('aData')) oData = oData.replace('aData', 'dataora')
        if (oData.includes('RagSoc_Contatto')) oData = oData.replace('RagSoc_Contatto', 'contatto')
        const valida = this.crmFiltriAggForm.validate().isValid
        if (valida) {
          this.myFilter = `?$filter=${oData}`
          this.crmFiltriAggGrid.refresh()

        }
      })
    } else {
      Object.keys(this.crmFiltriAggForm.dataSet).forEach((key) => {
        this.crmFiltriAggForm.dataSet[key] = null
      })
      Object.keys(this.crmFiltriAggForm.elementRef).forEach((key) => {
        this.crmFiltriAggForm.elementRef[key].editorComponent.showClearButton = false
      })
      this.myFilter = ''
      this.crmFiltriAggGrid.refresh()
    }
    return
  }
  emittedInitForm(e) {
    console.log(e)
  }
}
